import React, { useEffect, useState } from 'react'

const Rolefile = (props) => {

    const[RoleShortJson,setRoleShortJson]=useState(undefined);

useEffect(()=>
{
    fetchrole(props.id);

},[])


const fetchrole=async (id)=>
{
 
  let response =await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/users/${id}/groups`,
    {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      Accept: "application/json",

      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        Host: "localhost:8080",
        "Sec-Fetch-Mode": "cors",
        "Sec-Fetch-Site": "same-site",

        //  "Remote Address": "[::1]:8080",

        Authorization:process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url

      // body data type must match "Content-Type" header
    }
  );

  let data = await response.json();



 
  const rolefound=await data.find((data)=>
   {
    if(data.path=="/formsflow/formsflow-reviewer/approver")
    {
        return data;
    }
    if(data.path=="/formsflow/formsflow-client")
    {
       
        return data;
    }
    if(data.path=="/formsflow/formsflow-reviewer/clerk")
    {
       
        return data;
    }


if(data.path=="/formsflow/formsflow-designer")
{
   
    return data;
}

  })



  setRoleShortJson(rolefound);



  

  

}

    
  return (
    <div>{RoleShortJson==undefined?"No role assigned yet" :RoleShortJson.path}</div>
  )
}

export default Rolefile